import styled from "styled-components";

export const ErrorWrapper = styled.div`
  width: 100%;
  display: flex;
  // position: absolute;
`;

export const ErrorMsgWrapper = styled.div`
  width: 100%;
  // max-width: 600px;
  margin: 0 auto;
  background-color: ${(props) => props.theme.colors.alertErrorSecondary};
  padding: 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ErrorMsgImgWrapper = styled.div`
  width: 60px;
  height: 60px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 8px;
`;

export const ErrorCardImg = styled.img`
  /* width: 60px;
  height: 60px;
  border-radius: 8px; */
`;